import './Home.css';

function Home() {
  return (
    <section id="home" className="d-flex">
      <div className="my-auto">
        <span className="name">Dicky Ku</span>
        <h1>Major in Mathematics</h1>
        <h1>Minor in Computer Science</h1>
      </div>
      
    </section>
  );
}

export default Home;
